import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { getPropertiesRpc } from '../../../__generated__/chirp/com/hubspot/custom/enrichment/rpc/client/PropertyConfigService';
import { COMPANY_TYPE_ID } from '../../constants';
import { transformSmartProperties } from './transforms';
const rpcClient = createRpcClientV2({
  hubHttpClient: http
});
export const fetchSmartProperties = async () => {
  const companySmartPropertiesResponse = await rpcClient.call(getPropertiesRpc, {
    request: {
      objectType: COMPANY_TYPE_ID
    }
  });
  return transformSmartProperties(companySmartPropertiesResponse.properties);
};